module.exports = __webpack_public_path__ + "img/mutuoacuerdo.4352e3b6.png";